// ChurchTimeline.jsx
import React from 'react';
import image1 from '../../images/timeline/1.png';
import image2 from '../../images/timeline/2.png';
import image3 from '../../images/timeline/3.png';
import image4 from '../../images/timeline/4.png';
import image5 from '../../images/timeline/5.png';
import martin from '../../images/timeline/martin.png';
import william from '../../images/timeline/william.png';
import john from '../../images/timeline/john.png';
import thomas from '../../images/timeline/thomas.png';
import buttons from '../../images/timeline/buttons.png';
import ulrich from '../../images/timeline/ulrich.png';
import TimelineBar from './TimelineBar';
import { Link } from 'gatsby';

export default function Timeline() {
  return (
    <div className="timeline-container">
      {/* Main Title */}
      <h1 className="main-title">
        TIMELINE OF
        <br className="mobile-breakpoint" /> CHURCH HISTORY
      </h1>

      <p className="mobile-description">
        Explore key moments that shaped the Church—from its beginnings to today.Navigate centuries of faith,
        movements,and milestones through our interactive timeline.
      </p>

      {/* Cards Container */}
      <div className="cards-container">
        {/* Left Card - William Tyndale */}
        <div className="card card-left">
          <div className="card-image-overlay">
            <img src={image1} alt="img" className="card-image" />
          </div>
        </div>

        {/* Background Card 1 */}
        <div className="card card-inner-left">
          <div className="card-image-overlay">
            <img src={image2} alt="img" className="card-image" />
          </div>
        </div>

        {/* Center Card - Martin Luther (Featured) */}
        <div className="card card-center">
          <img src={image3} alt="img" className="card-image" />
        </div>

        {/* Background Card 2 */}
        <div className="card card-inner-right">
          <div className="card-inner-right-overlay">
            <img src={image4} alt="img" className="card-image" />
          </div>
        </div>

        {/* Right Card - John Calvin */}
        <div className="card card-right">
          <div className="card-image-overlay">
            <img src={image5} alt="img" className="card-image" />
          </div>
        </div>
      </div>

      {/* Timeline Component */}
      <TimelineBar />

      {/* Description */}
      <p className="description">
        Explore key moments that shaped the Church—from its
        <br />
        beginnings to today. Navigate centuries of faith, movements, and
        <br />
        milestones through our interactive timeline.
      </p>

      {/* Explore All Button */}
      <div className="button-container">
        <Link to="/timeline/" className="explore-btn">
          EXPLORE ALL
        </Link>
      </div>

      <div className="martin-card">
        <img src={martin} alt="img" className="card-image" />
      </div>
      <div className="thomas-card">
        <img src={thomas} alt="img" className="card-image" />
      </div>
      <div className="ulrich-card">
        <img src={ulrich} alt="img" className="card-image" />
      </div>
      <div className="buttons-card">
        <img src={buttons} alt="img" className="card-image" />
      </div>
      <div className="john-card">
        <img src={john} alt="img" className="card-image" />
      </div>
      <div className="william-card">
        <img src={william} alt="img" className="card-image" />
      </div>
    </div>
  );
}
